import { AxiosResponse } from "axios";
import { authenticationApiUrls as apiUrl } from "@/apps/merchant3/services/apiClient/apiUrl";
import { apiClient } from "@/apps/merchant3/services/apiClient/apiClient";
import { store } from "@/shared-store";
import { IPaymentTerms, IStateCart } from "@/apps/merchant3/models/IStateCart";
import EventLogs from "@/apps/merchant3/types/EventLogs";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";
import { Store } from "vuex";
import { getDeviceType } from "@/apps/merchant3/shared-helpers/device-detect.helper";
import {
  IPreRegDevices,
  IPreRegPaymentTerm,
} from "@/apps/merchant3/models/IStateOffers";

import logAnalyticsEvent from "@/apps/merchant3/services/google-analytics-events.service";
import { LocationQuery } from "vue-router";

type BasicTypes = string | number | boolean | null | undefined;
type AcceptedValues =
  | IPaymentTerms
  | BasicTypes
  | IPreRegDevices
  | IStateCart
  | IPreRegPaymentTerm
  | LocationQuery;

export const logEvent = async (
  name: string,
  data?: Record<string, AcceptedValues> | BasicTypes
): Promise<AxiosResponse<unknown>> => {
  const vuexStore = store as unknown as Store<IVuexState>;
  const deviceType = getDeviceType();
  const previousPage = history.state?.back;
  const currentPage = location.href;

  const eventLogData = {
    merchantId: vuexStore.state.merchant?.merchant?.merchantId,
    clerkId: vuexStore.state.clerk?.clerk?.salesClerkId,
    cartId: vuexStore.state.carts?.cartId,
    cartTag: vuexStore.state.carts?.cartTag,
    userId: vuexStore.state.carts?.userId,
    userTag: vuexStore.state.carts?.userTag,
    adminId: vuexStore.state.merchant?.merchant?.adminId,
    currentURL: currentPage,
    previousURL: previousPage,
    page: vuexStore.state.carts?.step,
    deviceType: deviceType,
    productName: vuexStore.state.carts?.productVersion,
    source: "Frontend",
    bandwidth: (window.navigator as Navigator & { connection?: { downlink?: number; effectiveType?: string; rtt?: number } })?.connection?.downlink,
    networkType: (window.navigator as Navigator & { connection?: { downlink?: number; effectiveType?: string; rtt?: number } })?.connection?.effectiveType,
    latency: (window.navigator as Navigator & { connection?: { downlink?: number; effectiveType?: string; rtt?: number } })?.connection?.rtt,
    data,
  };

  const nowInUTC = new Date().toUTCString();
  const utcTimestamp = Math.floor(new Date(nowInUTC).getTime() / 1000);

  logAnalyticsEvent(name);

  return await apiClient.post(apiUrl.EVENT_LOG, {
    name,
    category: EventLogs.Category,
    timestamp: utcTimestamp,
    data: eventLogData,
  });
};

export default logEvent;
